<body>

    <div class="container-fluid" [ngClass]="{'dark-bg' : isDark }">
      <div class="row">
        <div class="col-12">                
          <div class="invoice p-3 mb-3"> 

            <div class="row justify-content-center">
                <h6>Item Sales Report</h6> 
            </div>

            <!-- Tabele row -->
            <div class="row">
            <div class="col-12">
            <div class="card" [ngClass]="{'dark-bg' : isDark ,'dark-border-color' : isDark }">                  
             <div class="card-body">

               <div class="row pb-2">
                <div class="col-4 input-group">
                    <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                        </div>
                        <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="fromDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="From Date">
                      </div>
                  </div>
                <div class="col-4 input-group">
                    <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                        </div>
                        <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="toDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="To Date">
                      </div>
                </div>
                <div class="col-4 input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                  </div>
                  <select [ngClass]="{'dark-input-field' : isDark }"[(ngModel)]="paymentType" class="form-control">        
                    <option [ngValue]="null">-Select Term-</option>
                    <option *ngFor="let item of PMT_TYPE" [value]="item.value">
                      {{item.value}}
                    </option>
                </select>
                </div>
                </div>

                <div class="row pb-2">
                    <div class="col-4 input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-credit-card"></i></span>
                      </div>
                      <select [ngClass]="{'dark-input-field' : isDark }"[(ngModel)]="salesType" class="form-control">        
                        <option [ngValue]="null">-Select Sales Type-</option>
                        <option *ngFor="let item of SALES_TYPE" [value]="item.value">
                          {{item.value}}
                        </option>
                    </select>
                    </div>

                    <div class="col-5  input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
                      </div>
                      <input [ngClass]="{'dark-input-field' : isDark }" type="text" [formControl]="myControl"  [(ngModel)]="itemCode"  [matAutocomplete]="autoCustomer" class="form-control"  placeholder="Product Name">
                      <mat-autocomplete autoActiveFirstOption  #autoCustomer="matAutocomplete">
                        <mat-option *ngFor="let option of filteredItemList | async" [value]="option.ItemCode">
                          {{option.ItemCode}}
                        </mat-option>
                      </mat-autocomplete> 
                    </div>

                    <div class="col-3 input-group">
                      <button (click)="viewBtnClicked()" mat-raised-button>View</button>
                      <button (click)="clearBtnClicked()" mat-raised-button class="ml-2">Clear</button>                         
                    </div>
                </div>

              <div class="col-12 table-responsive mt-2" id="salesReport">
                <table class="table" [ngClass]="{'dark-bg' : isDark }">
                  <thead>
                  <tr >                          
                    <th>InvoiceDate</th>
                    <th>InvoiceNo</th>
                    <th>Product</th>                        
                    <th>Term</th>                         
                    <th>Sales Type</th>
                    <th class="text-right">UnitPrice</th>
                    <th class="text-right">Qty</th>
                    <th class="text-right">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let item of filteredInvoiceList">    
                    <td>{{item.InvoiceDate | date :'y-MM-dd'}}</td>
                    <td>{{item.InvoiceNo}}</td>
                    <td>{{item.ItemCode}}</td>   
                    <td>{{item.PaymentType}}</td>
                    <td>{{item.SalesType}}</td>  
                    <td class="text-right">{{item.DiscountPrice |  number:'1.2-2'}}</td> 
                    <td class="text-right">{{item.Qty |  number:'1.2-2'}}</td>  
                    <td class="text-right">{{item.Amount |  number:'1.2-2'}}</td>                                                                                   
                  </tr>  
                  <tr class="table-active">
                    <td colspan="4" class="text-right text-bold">Total Qty :</td>
                    <td class="text-bold">{{getTotalQty()}}</td>
                    <td colspan="2" class="text-right text-bold">Total Amount :</td>
                    <td class="text-right text-bold">{{getTotalAmount() | number:'1.2-2'}}</td>
                  </tr>                                                             
                  </tbody>
                </table>
              </div>
              <!-- /.col -->
             </div>
            </div>
            </div>
            </div>
            <!-- /.row -->


            <!-- this row will not appear when printing -->
            <div class="row no-print">
              <div class="col-12">
                <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('print')"  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>      
                <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
                <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('open')"  class="btn btn-default float-right"><i class="fa fa-file-pdf-o" style="color:red"></i> PDF</button>                                                                                                                                                              
              </div>
            </div>


          </div><!-- /.invoice -->                 
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->         
</body>






